import check from "../../assets/check.png";
import uncheck from "../../assets/uncheck.png";

function CoalitionCheckbox({ checked = false, onChange }) {
  return (
    <label className="inline-flex items-center cursor-pointer mr-4">
      <div className="relative">
        <input
          type="checkbox"
          className="hidden"
          checked={checked}
          onChange={onChange}
        />
        <div className="w-8 h-8 flex items-center justify-center">
          {checked ? (
            <img src={check} alt="Checked" className="h-8 w-8" />
          ) : (
            <img src={uncheck} alt="Unchecked" className="h-8 w-8" />
          )}
        </div>
      </div>
    </label>
  );
}

export default CoalitionCheckbox;
